import { render, staticRenderFns } from "./ConfigUserBusinessAccount.vue?vue&type=template&id=58f066f1&"
import script from "./ConfigUserBusinessAccount.vue?vue&type=script&lang=js&"
export * from "./ConfigUserBusinessAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUserBusinessAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports